<div class="row_1">
        <label class="label tab-heading titlered">Tier Level</label>

        <button class="primarybutton" style="float: right;" *ngIf="false" (click)="AddToQueue();">Add To
                Queue</button>

        <div class="top_grid_agg">
                <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
                </app-notification-message>
                <img src="./assets/images/refresh_button.svg" class="refresh-button" (click)="refresh()">
                <label class="drpdwn_period_label ">Period : {{ PeriodLabel }}</label>
                <img src="./assets/images/vertical_line.svg" class="period-line">
                <label class="drpdwn_period_label">Tier :</label>
                <select [(ngModel)]="selected_position_id" [ngModelOptions]="{standalone: true}"
                        style="font-family:Roboto;font-size:13px" class="drpdwn_period" (change)="onTierChange()">
                        <option *ngFor="let tierItem of tierItems" [value]="tierItem.tierPosition">
                                {{tierItem.description}}
                        </option>
                </select>

                <label class="drpdwn_period_label">Round :</label>

                <select [(ngModel)]="selected_round_id" [ngModelOptions]="{standalone: true}"
                        style="font-family:Roboto;font-size:13px" class="drpdwn_period" (change)="onRoundChange()">
                        <option *ngFor="let roundItem of roundItems" [value]="roundItem">
                                {{roundItem}}
                        </option>
                </select>


                <mat-slide-toggle class="slide_completed togglealign" [(ngModel)]="isCompleted"
                        (change)="onCompleteChange()">Completed</mat-slide-toggle>
                <mat-slide-toggle class="slide_completed togglealign" [(ngModel)]="isVerified"
                        (change)="onVerificationChange()">Verification</mat-slide-toggle>
                <mat-slide-toggle class="slide_completed togglealign" [(ngModel)]="isRoutes"
                        (change)="onRoutesChange()">My Routes</mat-slide-toggle>





                <img src="./assets/images/export_black.svg" class="export-icon" (click)="onBtExport()">

                <div class="grid-agg">

                        <label class="gridcaption">Routes</label>
                        <ag-grid-angular #agGrid style="width: 100%; height: 390px;" id="LIOS-GRID" [gridOptions]="gridOptions"
                                (window:resize)="sizeToFit()" [defaultColDef]="defaultColDef" class="ag-theme-balham"
                                [columnDefs]="columnDefs" [rowData]="rowData"  
                                [context]="context" [icons]="icons" [pagination]="true" [paginationPageSize]="rowCount"
                                (gridReady)="onGridReady($event)">
                        </ag-grid-angular>

                        <div class="row col-12" style="bottom: 24px;position: relative; padding-left :13px">

                                <div class="w-25 col-4 ">
                                        <div>
                                                <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                                                <select class="page-navigation" (change)="onPageSizeChanged($event)">
                                                        <option value="5">5</option>
                                                        <option value="10">10</option>
                                                        <option value="20">20</option>
                                                        <option value="50">50</option>
                                                        <option value="ALL" selected>ALL</option>
                                                </select>
                                                <!-- <label style="padding-left:9px"> of {{rowCount}}</label> -->
                                        </div>
                                </div>

                                <div style="display: flex;" class="pagination_text col-4 offset-2">

                                        <!-- first -->
                                        <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToFirstPage()"
                                                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                                                first_page</mat-icon>

                                        <!-- previous -->
                                        <mat-icon style="cursor: pointer; margin-top: -4px;"
                                                (click)="goToPreviousPage()"
                                                [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                                                keyboard_arrow_left</mat-icon>

                                        <p class="total_row_text">Total Row {{rowCount}}</p>

                                        <!-- next -->
                                        <mat-icon style="cursor: pointer; margin-top: -4px;"
                                                [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                                                (click)="goToNexpage()">keyboard_arrow_right
                                        </mat-icon>

                                        <!-- last -->
                                        <mat-icon style="cursor: pointer; margin-top: -4px;"
                                                [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                                                (click)="goToLastPage()">last_page
                                        </mat-icon>

                                </div>

                        </div>
                </div>
        </div>